import React, { useState, useEffect } from "react";
import { Button, Modal, Text, Icon } from "@website-builder/ui/shared/elements";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";
import {
	callUserAPI,
	callLearningPathInterestedAPI,
} from "@website-builder/utilities/utils/utils.js";
import { LearningPathModalWrapper } from "./styles";

const LearningPathPopup = ({
	text = "",
	subtext = "",
	CTA: [cta] = [null],
	workshopId = "",
	context,
}) => {
	const [show, setShow] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				const apiBaseUrl = context?.apiBaseUrl;
				const response = await callUserAPI(apiBaseUrl);

				if (response?.code === 200) {
					const userHasClickedCTA =
						window.location.href.indexOf("lps=true") > -1;
					try {
						// lps stands for Learning Path Submitted
						if (
							userHasClickedCTA &&
							sessionStorage.getItem("lps_" + workshopId) !== "true"
						) {
							sessionStorage.setItem("lps_" + workshopId, "true");
							const additionalInterestedAPIFields = {
								source: "lp",
								referral: window?.location?.href,
							};
							await callLearningPathInterestedAPI(
								response?.email,
								workshopId,
								apiBaseUrl,
								additionalInterestedAPIFields,
							);
						}
					} catch (err) {
						console.error(err);
					}

					if (userHasClickedCTA) {
						setShow(true);
					}
				}
			} catch (err) {
				console.error("Something went wrong while fetching /user api: ", err);
			}
		})();
	}, [context]);

	return (
		<LearningPathModalWrapper>
			<Modal
				show={show}
				disableBackdropClick={true}
				onClose={() => setShow(false)}
				className="learning-path-modal"
			>
				<div className="learning-path-modal-content">
					<Icon iconName="learningPathCheck" />
					{text ? (
						<Text variant="headline_3" tag="p">
							{text}
						</Text>
					) : null}
					{subtext ? <Text variant="paragraph_L">{subtext}</Text> : null}
					{cta ? (
						<Button
							{...cta}
							onClick={() => {
								handleCTAClick(cta, {
									page_section: "Learning Path Popup",
									click_text: cta?.buttonText,
									redirect_to: cta?.link?.link,
								});
							}}
						></Button>
					) : null}
				</div>
			</Modal>
		</LearningPathModalWrapper>
	);
};

export default LearningPathPopup;
